import { inject } from '@angular/core';
import { Router, type CanMatchFn, RedirectCommand } from '@angular/router';

import { type PermissionKey } from '@entities/profile';

import { PermissionService } from '@core/auth';

export function permissionGuard(permissions: PermissionKey | PermissionKey[]): CanMatchFn {
  return () => {
    const router = inject(Router);
    const permissionService = inject(PermissionService);

    const hasAccess = Array.isArray(permissions)
      ? permissionService.hasAll(permissions)
      : permissionService.has(permissions);

    return hasAccess || new RedirectCommand(router.createUrlTree(['/dashboard']), { replaceUrl: true });
  };
}
